var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilVectorGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2583 3.8668C15.5833 3.5418 15.5833 3.00013 15.2583 2.6918L13.3083 0.741797C13 0.416797 12.4583 0.416797 12.1333 0.741797L10.6 2.2668L13.725 5.3918L15.2583 3.8668ZM0.5 12.3751V15.5001H3.625L12.8417 6.27513L9.71667 3.15013L0.5 12.3751Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilVectorGrey);
export default __webpack_public_path__ + "static/media/pencilVectorGrey.7bd0b328c500e89290dbb987bb2bfe31.svg";
export { ForwardRef as ReactComponent };